import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';
import { Button } from '@repo/videa-components/src/index';

export const PaginationControl = ({
  hasPagination,
  currentPage,
  pages,
  handleSetPage,
}: {
  hasPagination: boolean;
  currentPage: number;
  pages: number;
  handleSetPage: (direction: 'prev' | 'next') => void;
}) => {
  const currentPageNumber = currentPage + 1;

  return hasPagination ? (
    <div className="vai-w-full vai-flex vai-justify-center vai-absolute vai-z-50 vai-bottom-20">
      <div className="vai-bg-blue-black-640 vai-rounded-md vai-cursor-pointer vai-shadow-md vai-flex vai-items-center vai-justify-center vai-gap-4 vai-bg-gray-500 vai-text-white vai-p-1">
        <Button
          onClick={() => handleSetPage('prev')}
          data-testid="claim-summary-pagination-prev"
          disabled={currentPage === 0}
          variant="ghost"
          size="xs"
          className="hover:vai-bg-gray-600 hover:vai-text-white"
        >
          <FontAwesomeIcon icon={faArrowLeft} />
          <Trans>Previous</Trans>
        </Button>
        <span>
          {currentPageNumber}
          <Trans> of </Trans>
          {pages}
        </span>
        <Button
          onClick={() => handleSetPage('next')}
          data-testid="claim-summary-pagination-next"
          disabled={currentPage === pages - 1}
          variant="ghost"
          size="xs"
          className="hover:vai-bg-gray-600 hover:vai-text-white"
        >
          <Trans>Next</Trans>
          <FontAwesomeIcon icon={faArrowRight} />
        </Button>
      </div>
    </div>
  ) : null;
};
